module.exports = __webpack_public_path__ + "static/media/bhsLogo_v4black.66020d6f.jpg";